#import "../fragments/competitors-lead-fragment.graphql"

query GetCompetitorsForLead($leadId: ID!) {
    lead(id: $leadId) {
        ...CompetitorsLeadFragment
    }
}
